// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayloadStagingV1MetaDataGetMetaDataSystemCodeSystemIdPurposeCodePurposeIdGetMetaDataResponse {
    static getAttributeTypeMap() {
        return PayloadStagingV1MetaDataGetMetaDataSystemCodeSystemIdPurposeCodePurposeIdGetMetaDataResponse.attributeTypeMap;
    }
}
PayloadStagingV1MetaDataGetMetaDataSystemCodeSystemIdPurposeCodePurposeIdGetMetaDataResponse.discriminator = undefined;
PayloadStagingV1MetaDataGetMetaDataSystemCodeSystemIdPurposeCodePurposeIdGetMetaDataResponse.additionalProperties = false;
PayloadStagingV1MetaDataGetMetaDataSystemCodeSystemIdPurposeCodePurposeIdGetMetaDataResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payloadStagingV1MetaDataGetMetaDataSystemCodeSystemIdPurposeCodePurposeIdGetMetaDataResponse.js.map